<template>
  <v-footer padless style="background: #707070">
    <v-container class="white--text px-4 py-4">
      <!-- Footer Header -->
      <div class="py-2 text-body-1 font-weight-medium">
        MARKETPETT V1.2.4 (BETA)
      </div>

      <!-- Social Link -->
      <div class="btn-link">
        <v-btn
          class="font-weight-light white--text"
          href="https://www.facebook.com//Marketpett.official"
          target="_blank"
          small
          plain
          :ripple="false"
        >
          <v-icon x-small class="mr-1">fab fa-facebook-square</v-icon>
          Facebook
        </v-btn>&nbsp;
        <v-btn
          class="font-weight-light white--text"
          href="https://www.instagram.com/marketpett_"
          target="_blank"
          small
          plain
          :ripple="false"
        >
          <v-icon x-small class="mr-1">fab fa-instagram</v-icon>
          Instagram
        </v-btn>&nbsp;
        <v-btn
          class="font-weight-light white--text"
          href="https://twitter.com/marketpett_twt"
          target="_blank"
          small
          plain
          :ripple="false"
        >
          <v-icon x-small class="mr-1">fab fa-twitter</v-icon>
          Twitter
        </v-btn>
      </div>

      <!-- Link to page (in this site) -->
      <div class="btn-link pb-1">
        <router-link to="/" class="mr-1 link text-caption grey--text text--lighten-2">หน้าหลัก</router-link>&nbsp;
        <router-link to="/aboutus" class="mr-1 link text-caption grey--text text--lighten-2">เกี่ยวกับเรา</router-link>&nbsp;
        <span style="white-space: nowrap">
          <router-link to="/terms-and-conditions" class="mr-1 link text-caption grey--text text--lighten-2">ข้อกำหนดการใช้งาน</router-link>&nbsp;
          <router-link to="/privacy-policy" class="mr-1 link text-caption grey--text text--lighten-2">นโยบายความเป็นส่วนตัว</router-link>
        </span>
      </div>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  data() {
    return {
      icons: ["mdi-facebook", "mdi-google", "mdi-instagram"],
    };
  },
};
</script>

<style scoped>
.btn-link > .v-btn {
  height: 28px;
  min-width: unset;
  padding-left: 0;
  padding-right: 0;
  margin-right: 8px;
}
</style>